import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/min/moment-with-locales';
import Moment from "react-moment";

const $ = window.jQuery;

class PredefinedDateRangePicker extends Component {
    static propTypes = {
        className: PropTypes.string,
        opens: PropTypes.string,
        drops: PropTypes.string,
        startDate: PropTypes.any,
        endDate: PropTypes.any,
        onChange: PropTypes.func.isRequired
    };
    static defaultProps = {
        opens: 'center',
        drops: 'down',
        autoApply: false
    };
    state = {
        startDate: moment(this.props.startDate),
        endDate: moment(this.props.endDate)
    };
    format = 'D MMMM YYYY';

    componentDidMount() {
        const {opens, drops, onChange, ...props} = this.props;

        this.$el = $(this.el);
        this.$el.daterangepicker({
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            opens: opens,
            drops: drops,
            autoApply: true,
            ranges: {
                'Сегодня': [moment(), moment()],
                'Завтра': [moment().add(1, 'days'), moment().add(1, 'days')],
                'Следующие 7 дней': [moment(), moment().add(6, 'days')],
                'Следующие 30 дней': [moment(), moment().add(29, 'days')],
                'Этот месяц': [moment().startOf('month'), moment().endOf('month')]
            },
            locale: {
                format: this.format,
                separator: " - ",
                applyLabel: "Применить",
                cancelLabel: "Отмена",
                fromLabel: "От",
                toLabel: "До",
                customRangeLabel: "Свой",
                daysOfWeek: [
                    "Вс",
                    "Пн",
                    "Вт",
                    "Ср",
                    "Чт",
                    "Пт",
                    "Сб"
                ],
                monthNames: [
                    "Январь",
                    "Февраль",
                    "Март",
                    "Апрель",
                    "Май",
                    "Июнь",
                    "Июль",
                    "Август",
                    "Сентябрь",
                    "Октябрь",
                    "Ноябрь",
                    "Декабрь"
                ],
                firstDay: 1
            }
        }, (startDate, endDate) => {
            this.setState({startDate, endDate}, () => {
                onChange(startDate, endDate);
            });
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            startDate: moment(nextProps.startDate),
            endDate: moment(nextProps.endDate)
        });
    }

    render() {
        const {className, before, after, ...props} = this.props;
        return (
            <button ref={el => this.el = el} className={`btn ${className || ''}`} type="button">
                <i className="fa fa-calendar m-r-1"/>
                <Moment format={this.format}>{this.state.startDate}</Moment>
                &nbsp;&mdash;&nbsp;
                <Moment format={this.format}>{this.state.endDate}</Moment>
            </button>
        );
    }
}

export default PredefinedDateRangePicker;


// WEBPACK FOOTER //
// ./src/controls/PredefinedDateRangePicker.js